// app/profilo/profilo.js

(function () {
    'use strict';
    var controllerId = 'profilo';
    angular.module('app').controller(controllerId, ['common', 'bootstrap.dialog', '$location', '$window', '$rootScope', '$routeParams', '$uibModal', 'datacontext', 'sectionMenu', '$filter', '$translate', profiloFn]);

    function profiloFn(common, bDialog, $location, $window, $rootScope, $routeParams, $uibModal, datacontext, sectionMenu, $filter, $translate) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');
        $rootScope.dashview = ""; // Azzera la classe dashview utile solo nelle dashboard 

        var vm = this;
        vm.sectionMenu = sectionMenu.setSection('Profilo');
        vm.record = {};                
        vm.provincie = [];
        vm.comuni = [];
        vm.update = updateItem;
        vm.getComuni = getComuni;
        vm.setConsenso = setConsenso;

        vm.loading = false;
        vm.formInvalid = true;
        vm.lingua = [{ name: $translate.instant('Italiano'), value: 'it' }, { name: $translate.instant('Inglese'), value: 'en' }];

        // ---- ACTIVATE -------
        activate();

        function activate() {
            var promises = [$rootScope.getWhoAmI()];
            common.activateController(promises, controllerId)
                    .then(function () {
                        vm.record = getStudente();                        
                    });
        }
        
        function getStudente() {
            if (vm.provincie.length == 0) getProvincie();            
            return datacontext.studente_getByUsername().then(function (data) {
                getComuni(data.ProvinciaId);
                vm.record = data;
                validaForm();
                vm.record.Lingua = $rootScope.lingua;
                return vm.record;
            });
        }

        function getProvincie() {
            if (vm.provincie.length > 0) return;

            datacontext.arrProvincie().then(function (data) {
                vm.provincie = data;
            });
        }

        function getComuni(idprov) {
            if (!idprov || idprov == 0) return vm.comuni = [];

            return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return vm.comuni = data;
            });
        }

        function updateItem() {
            validaForm();
            if (vm.formInvalid == false) {
                return datacontext.studente_update(vm.record).then(function (data) {
                    if (!data) {    //Il salvataggio è andato a buon fine
                        //$translate.use(vm.record.Lingua);

                        $translate.use(vm.record.Lingua);
                        vm.currentLanguage = vm.record.Lingua;
                        activate();//aggiunto per bug lingua          

                        if (vm.currentLanguage == 'it') {
                            vm.lingua = [{ name: 'Italiano', value: 'it' }, { name: 'Inglese', value: 'en' }];
                            logSuccess('Dati Salvati');
                        }
                        else {
                            vm.lingua = [{ name: 'Italian', value: 'it' }, { name: 'English', value: 'en' }];
                            logSuccess('Saved Data');
                        }

                        //logSuccess($translate.instant('DatiSalvati'));
                        //console.info("if", $translate);
                    }
                    else
                        logError($translate.instant('ImpossibileSalvareDati'));
                });
            }

            /* return datacontext.studente_update(vm.record).then(function (data) {                
                if (!data)
                    logSuccess($translate.instant('DatiSalvati'));
                else
                    logError($translate.instant('ImpossibileSalvareDati'));

                validaForm();
                $translate.use(vm.record.Lingua);
            });*/
        }

        function validaForm() {            
            vm.formInvalid = true;             
            if (vm.record.Email == null || vm.record.Email.trim().length == 0) {
                return;
            }

            vm.formInvalid = false;
        }

        function setConsenso() {
            if (vm.record.ConsensoDati)
                vm.record.DataConsenso = new Date();
            else
                vm.record.DataConsenso = null;
        }        
    }
})();
